export default "__VITE_ASSET__19rOREgV__"